import * as React from 'react';

const CheckRound = ({ ...props }) => (
  <svg width={28} height={28} viewBox="-2 -2 24 22" version="1.1" {...props}>
    <defs>
      <circle id="path-1" cx="10" cy="10" r="10" />
    </defs>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="shared-trip" transform="translate(-28.000000, -98.000000)">
        <g id="Group" transform="translate(24.000000, 89.000000)">
          <g id="Group-4-Copy-3" transform="translate(4.000000, 0.000000)">
            <g id="Group-10" transform="translate(0.000000, 9.000000)">
              <polyline
                id="Shape"
                stroke="#505FB4"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                points="21 1 10 12 7 9"
              />
              <mask id="mask-2" fill="white">
                <use xlinkHref="#path-1" />
              </mask>
              <use id="Mask" fill="#505FB4" xlinkHref="#path-1" />
              <polyline
                id="Shape"
                stroke="#FFFFFF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                mask="url(#mask-2)"
                points="21 1 10 12 7 9"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default CheckRound;



// WEBPACK FOOTER //
// ./src/assets/images/icons/check-round.js